import { __decorate } from "tslib";
import { TaskType } from '@blade-sxp/monitor/interfaces/control';
import { Component, Vue, Prop } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    taskConfig;
    taskType;
    get isDistanceTooClose() {
        return this.taskType === TaskType.DistanceTooClose;
    }
    get isCrowded() {
        return this.taskType === TaskType.Crowded;
    }
    get isGathering() {
        return this.taskType === TaskType.Gathering;
    }
};
__decorate([
    Prop()
], default_1.prototype, "taskConfig", void 0);
__decorate([
    Prop()
], default_1.prototype, "taskType", void 0);
default_1 = __decorate([
    Component({
        name: 'description',
        i18n: {
            messages: {
                en: {
                    socialDistance: 'Social distance threshold',
                    numberThreshold: 'Threshold Number of People',
                    pair: 'pair',
                    durationThreshold: 'Duration threshold',
                    area: 'Area',
                    distanceThreshold: 'Distance threshold',
                },
                zh: {
                    socialDistance: '社交距离阈值',
                    numberThreshold: '人数阈值',
                    pair: '对',
                    durationThreshold: '时长阈值',
                    area: '区域面积',
                    distanceThreshold: '距离阈值',
                }
            }
        }
    })
], default_1);
export default default_1;
;
